<template>
  <div style="background-color: #EDF0F5;text-align: center;padding-bottom: 20px;">
    <van-image :src="detailInfo.headImage" fit="fill" height="300" width="100%" />
    <div
      style="background-color: #FFFFFF;width: 90%;position: relative; top: -30px;border-radius: 8px;margin-left: 5% ;text-align: left">
      <div style="padding: 16px;">
        <span style="font-size: 21px;font-weight: bold;">{{ detailInfo.name }}</span>
        <br />
        <van-tag v-for="tag in tags" :key="tag" color="#e7f5ff" size="large" style="margin-right: 4px;margin-top: 8px;"
          text-color="#29a2ff">{{ tag }}
        </van-tag>
        <br />
        <div style="display: block;margin-top: 16px;line-height: 30px; color: #999999; vertical-align:middle;">
          <span><van-icon name="location-o" size="20" style="position: relative;top: 3px;" />
            {{ detailInfo.address }}</span><br />
          <span>
            <van-icon name="clock-o" size="20" style="position: relative;top: 3px;" /> {{ detailInfo.openTime }}
          </span>
          <br />
          <span style="color: #f00;">
            <span id="J_description" class="m-content overflow-line" style="">
              <van-icon color="#f00" name="info-o" size="20" style="position: relative;top: 3px;" /> {{ noteInfo }}
            </span>
            <a v-if="isShowMore" id="J_btnmore" class="btn-more" @click="showmoreDesc($event)">查看更多</a>
          </span>
        </div>
      </div>
    </div>

    <span style="text-align: left;width: 100%;display: block;margin-left: 16px;font-size: 22px;">套餐</span>

    <div v-for="goods in goodsList" :key="goods.goodsId"
      style="background-color: #FFFFff;width: 90%;border-radius: 8px;margin-left: 5%;margin-top: 8px;">
      <van-row>
        <van-col style="padding: 16px;">
          <van-image :src="goods.headImage" width="120"></van-image>
        </van-col>
        <van-col style="font-size: 16px;padding: 16px 4px;text-align: left;font-weight: bold;color: #666;"
          @click="goGoodsDetail(goods)">
          <div style="position: relative;height: 90px;">
            <span style="display: block;width: 160px;">{{ goods.name }}</span>
            <span style="color: #f84f43;font-size: 21px;position:absolute;bottom: 0;"><img alt=""
                src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png"
                style="  width: 24px;  height: 24px;" />{{ (goods.price / 100).toFixed(2) }}</span>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { getHospitalDetail, api_get_hospital_goods_list } from "@/api/goods-api";

export default {
  name: "detail",

  data() {
    return {
      detailInfo: {},
      extInfo: {},
      tags: [],
      goodsList: [],
      isShowMore: false,
      isDescStatus: true,
      noteInfo: ''
    }
  },

  created() {
    const id = this.$route.query.id || 0;

    getHospitalDetail(id).then(res => {
      budo_log.info("#76 created, getHospitalDetail, res=", res)

      if (res.code > 0) {
        Dialog.alert({ message: res.msg || "获取医院信息失败" }).then(() => {
          history.back()
        })
        return
      }

      // 渲染流程
      this.detailInfo = res.data;
      this.extInfo = JSON.parse(res.data.extInfo);
      this.tags = this.extInfo.lable.split(',');
      this.noteInfo = this.extInfo.note;
      if (this.noteInfo.length > 10) {
        this.isShowMore = true;
      }

      budo_log.info('#83 getHospitalDetail, tags=', this.tags)

      // 拿产品
      api_get_hospital_goods_list(id).then(res => {
        this.goodsList = res.data;
      })
    })
  },

  methods: {
    goGoodsDetail(goods) {
      if (goods.goodsId) {
        this.$router.push({ path: 'goods-detail', query: { goodsId: goods.goodsId } })
        return
      }

      this.$router.push({ path: 'goods-detail', query: { goodsId: "KANG_" + goods.sn } })
    },

    showmoreDesc(e) {
      let el = e.currentTarget;
      el.previousElementSibling.classList[!this.isDescStatus ? 'add' : 'remove']('overflow-line');
      el.classList[this.isDescStatus ? 'add' : 'remove']('more-collapse');
      el.innerHTML = !this.isDescStatus ? '查看更多' : '收起';
      this.isDescStatus = !this.isDescStatus;
      this.isShowMore = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.m-content {
  &.overflow-line {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
}

.btn-more {
  color: #5383E7;
  //position: relative;
  //margin-top: rc(5);
  //padding-right: rc(33);
  //
  //&.more-collapse {
  //
  //  &::after,
  //  &::before {
  //    top: 2px;
  //    transform: rotate(180deg);
  //  }
  //
  //  &::before {
  //    top: 4px;
  //  }
  //}
  //
  //&::after,
  //&::before {
  //  width: 0;
  //  height: 0;
  //  content: '';
  //  position: absolute;
  //  right: 0;
  //  top: 7px;
  //  border: rc(12) solid transparent;
  //}
  //
  //&::after {
  //  border-top-color: #5383E7;
  //  z-index: 1;
  //}
  //
  //&::before {
  //  border-top-color: #1c2239;
  //  z-index: 2;
  //  top: 5px;
  //}

}
</style>